export default {
  title: 'EquipmentType',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      format: 'string',
      fieldRequired: 'true',
      validationMessages: {
        required: 'Podaj nazwę typu sprzętu'
      }
    },
    mask: {
      type: 'string',
      format: 'string',
      fieldRequired: 'true',
      validationMessages: {
        required: 'Pole wymagane'
      }
    },
    id: {
      type: 'number',
      format: 'number',
      fieldRequired: 'false'
    }
  }
};
